import { BackendErrorCode, BACKEND_ERROR_MESSAGES, toApiError } from 'shared/errors';

/** GraphQL `MEDIA_MANAGER_TEMPLATE_NAME_CONFLICT`. */
export const TEMPLATE_NAME_CONFLICT_CODE = BackendErrorCode.MEDIA_MANAGER_TEMPLATE_NAME_CONFLICT;

/**
 * Message shown when the server rejects a name — same wording as the client-side check, and the
 * same descriptor as the registry text of 21409 (`shared/errors`).
 * Translate at the call site with `t(TEMPLATE_NAME_CONFLICT_MESSAGE)`.
 */
export const TEMPLATE_NAME_CONFLICT_MESSAGE = BACKEND_ERROR_MESSAGES[BackendErrorCode.MEDIA_MANAGER_TEMPLATE_NAME_CONFLICT]!;

/**
 * True when a write failed because the name is already taken in that scope.
 * Walks RTK Query (`error.data[0].extensions.code`) and repository-thrown
 * `UserError` (`error.extensions.code`).
 */
export function isTemplateNameConflict(error: unknown): boolean {
  return hasErrorCode(error, TEMPLATE_NAME_CONFLICT_CODE);
}

/** GraphQL `MEDIA_MANAGER_TEMPLATE_GROUP_NAME_CONFLICT`. */
export const TEMPLATE_GROUP_NAME_CONFLICT_CODE = BackendErrorCode.MEDIA_MANAGER_TEMPLATE_GROUP_NAME_CONFLICT;

export function isTemplateGroupNameConflict(error: unknown): boolean {
  return hasErrorCode(error, TEMPLATE_GROUP_NAME_CONFLICT_CODE);
}

/** Код из любой формы ошибки — разбор общий (`toApiError`): RTK Query, `GraphqlError`, `SerializedError`. */
function hasErrorCode(error: unknown, code: BackendErrorCode): boolean {
  return toApiError(error).code === code;
}

/**
 * Names are compared case- and whitespace-insensitively, matching the unique
 * index — otherwise the client would accept a name the DB then rejects.
 */
export function normalizeTemplateName(name: string): string {
  return name.trim().toLowerCase();
}
